import { COLORS } from '@btime/constants'
import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useFilterState } from '@btime/react-contexts'
import React from 'react'

import { Text } from '../../../components/presentation/Text'
import { serviceOrdersClient } from '../../../utils/apollo/api'
import { useQuery } from '../../../utils/apollo/_helpers/useQuery'
import useRouteParam from '../../../utils/routes/helpers/useParam'

const QUERY = gql`
  query ServiceOrdersHistoryCount($token: String, $placeId: Int, $assetId: Int) {
    serviceOrdersHistoryCount(token: $token, placeId: $placeId, assetId: $assetId)
  }
`

const ListCounter = ({ filters, flexiblePollInterval }) => {
  const token = useRouteParam(`token`)
  const entityId = useRouteParam('entityId')
  const entityType = useRouteParam('entityType')

  const { data, loading } = useQuery(QUERY, {
    variables: {
      token,
      ...(entityType === 'place' ? { placeId: parseInt(entityId) } : {}),
      ...(entityType === 'asset' ? { assetId: parseInt(entityId) } : {})
    },
    client: serviceOrdersClient,
    flexiblePollInterval: flexiblePollInterval || 120000
  })

  if (loading) return false

  return (
    <Text size="small" color={COLORS.dark3}>
      ({data?.serviceOrdersHistoryCount})
    </Text>
  )
}

export default ListCounter
